<template>
  <div id="app">
    <NavHeader ref="header"></NavHeader>
    <div style="padding-top: 90px;">
      <router-view @userLogin="handleUserLogin"/>
    </div>
    <PageFooter></PageFooter>
  </div>
</template>

<script>
import NavHeader from '@/components/NavHeader.vue'
import PageFooter from '@/components/PageFooter.vue'

export default {
  name: 'HelloWorld',
  components: {
    NavHeader,
    PageFooter
  },
  data () {
    return {
    }
  },

  methods: {
    handleUserLogin () {
      this.$refs.header.getUserInfo();
    }
  }
}
</script>
<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
